<template>
  <div>
    <headerBar :activeIndex="activeIndex"></headerBar>
    <banner :carousel="info.carousel" :Mcarousel="info.Mcarousel"></banner>
    <div class="honour">
      <div class="pc main-content" v-loading="loading">
        <div class="big-title" style="margin: 16px 0px; font-size: medium">
          <div class="big-name" style="font-size: 34px">医院荣誉</div>
          <div class="big-eng">
            <span class="line-left"></span>
            <span class="txt">HOSPITAL HONORS</span>
            <span class="line-right"></span>
          </div>
        </div>
        <div v-html="info.environment_content"></div>
      </div>
      <div class="mobile main-content" v-loading="loading">
        <div class="big-title" style="margin: 16px 0px; font-size: medium">
          <div class="big-name" style="font-size: 34px">医院荣誉</div>
          <div class="big-eng">
            <span class="line-left"></span>
            <span class="txt">HOSPITAL HONORS</span>
            <span class="line-right"></span>
          </div>
        </div>
        <div v-html="info.environment_content"></div>
      </div>
    </div>
    <footerBar></footerBar>
  </div>
</template>

<script>
import banner from "@/components/banner";
import headerBar from "@/components/header";
import footerBar from "@/components/footer";
import { getmenudetail } from "@/api/common";
export default {
  name: "department",
  components: { banner, footerBar, headerBar },
  data() {
    return {
      activeIndex: "honour",
      info: { carousel: "", Mcarousel: "" },
      loading: true,
    };
  },
  mounted() {
    getmenudetail({ id: 5 }).then((res) => {
      this.loading = false;
      if (res.data.banner_pc_images && res.data.banner_pc_images !== "") {
        res.data.carousel = res.data.banner_pc_images.split(",");
        res.data.Mcarousel = res.data.banner_mobile_images.split(",");
      }
      this.info = res.data;
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.honourImg {
  height: 200px;
}
@media screen and (max-width: 750px) {
  .honourImg {
    width: 70%;
    margin: 5px auto;
    height: auto;
  }
  .honour .mobile {
    zoom: 0.6;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/honour.vue